var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cards-list',{attrs:{"grid":"2","gap":"16"}},[_c('CardCompany',{staticClass:"h-100 min-h-40",attrs:{"part":"Tomador","enterprise":_vm.enterprise.borrower}}),_c('CardCompany',{staticClass:"h-100 min-h-40",attrs:{"part":"Prestador","enterprise":_vm.enterprise.provider}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }